module.exports = __webpack_public_path__ + "static/media/blank-profile.f5ef4263.png";